import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DetailFormDataModel } from '../../../config/model/detail-form-data.model';

@Component({
    selector: 'form-builder',
    templateUrl: './form-builder.component.html',
    styleUrls: ['./form-builder.component.scss'],
    standalone: false
})
export class FormBuilderComponent implements OnInit {
  @Input() graphicFormGroup: UntypedFormGroup;
  @Input() viewExpanded: boolean;
  @Input() detailFormDataModel: DetailFormDataModel;
  @Input() formattedFormFields: any;

  constructor() {}

  ngOnInit() {
    // Entfernt das Pseuso Initial FormControl, das von DetailView Component erstellt ist
    this.graphicFormGroup.removeControl('initial');
  }

  public calculateColumnWidth(prop: any): string {
    if (!this.viewExpanded || prop.field_component === 'full_divider') {
      return 'col-12'; // default set 1 column in small mode
    } else {
      if (this.detailFormDataModel.formColumns === 1) {
        return 'col-12';
      } else if (this.detailFormDataModel.formColumns === 2) {
        return 'col-6';
      } else if (this.detailFormDataModel.formColumns === 3) {
        return 'col-4';
      } else if (this.detailFormDataModel.formColumns === 4) {
        return 'col-3';
      } else {
        return 'col-6'; // default set 2 columns in expanded mode
      }
    }
  }
}
